import { FeatureFlags as CatalogFeatureFlags } from '@tableau/data-catalog-client-components';
import { defaultMemoize } from 'reselect';
import { FeatureFlags as VizportalClientFeatureFlags } from '../ts/FeatureFlags';

export const catalogFeatureFlagsAdapter = defaultMemoize((): CatalogFeatureFlags => {
  return {
    catalogSevereWarningsEnabled: VizportalClientFeatureFlags.catalogSevereWarningsEnabled,
    catalogTagsEnabled: VizportalClientFeatureFlags.catalogTagsEnabled
  };
});
